/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2BOrderHistoryData } from './aaa_b2b_order_history.data';
import { IAaa_b2b_order_historyProps } from './aaa_b2b_order_history.props.autogenerated';
import { getOrderHistoryAsync } from '../../dataActions/DataActionExtension.g';

export interface IAaaB2BOrderHistoryViewProps extends IAaa_b2b_order_historyProps<IAaaB2BOrderHistoryData> {
    currentPageItems: [];
    headers: [];
    total: number;
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    handlePageItemsChange: any;
    handleMouseEnterEvent: any;
    handleMouseOutEvent: any;
    mouseOverIndex: number;
    handleOnChangeInput: any;
    onClickSearchBox: any;
    resetItems: any;
    searchString: string;
    isLoading: boolean;
    getOrderDetailPageUrl: any;
}
export interface IAaaB2BOrderHistoryState {
    total: number;
    currentPageItems: [];
    headers: any;
    customerInfo: { AccountNumber: '' };
    totalItemPerPage: number;
    activePage: number;
    pageCount: number;
    mouseOverIndex: number;
    searchString: string;
    isLoading: boolean;
}

/**
 *
 * Aaa_b2b_order_history component
 * @extends {React.PureComponent<IAaa_b2b_order_historyProps<IAaaB2BOrderHistoryData>>}
 */
class Aaa_b2b_order_history extends React.Component<IAaa_b2b_order_historyProps<IAaaB2BOrderHistoryData>, IAaaB2BOrderHistoryState> {
    constructor(props: any) {
        super(props);
        this.state = {
            total: 0,
            currentPageItems: [],
            headers: ['Customer', 'Phone', 'Email', 'ConfirmationID', 'Order Number', 'Individual Price', 'Snapshot ID', 'Status', ''],
            customerInfo: { AccountNumber: '' },
            totalItemPerPage: this.props.config.totalItemPerPage ? this.props.config.totalItemPerPage : 8,
            activePage: 1,
            pageCount: 0,
            mouseOverIndex: 0,
            searchString: '',
            isLoading: true
        };
    }

    public async componentDidMount(): Promise<void> {
        await this.getRequestOrderList({ IncludeTotalCount: true }, this.state.activePage);
    }

    public getRequestOrderList = async (searchRequest: any, activePage: number) => {
        this.setState({ isLoading: true, currentPageItems: [] });
        const response: any = await getOrderHistoryAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            this.state.totalItemPerPage,
            activePage === 1 ? 0 : (activePage - 1) * this.state.totalItemPerPage,
            searchRequest
        );
        const data = { orders: response.Results, total: response.TotalRecords };
        // if manage orders length > 0 set active 1 per page 5,
        // divided mangage orders / per page 50/5=10 pagaes
        // if active is 1 page pick  0 to active -1 and push into cureent page items
        this.setState({
            currentPageItems: data.orders ? data.orders : [],
            isLoading: false,
            pageCount: data.total <= this.state.totalItemPerPage ? 1 : Math.ceil(data.total / this.state.totalItemPerPage),
            activePage: activePage,
            total: data.total
        });
    };
    private getOrderDetailPageUrl = (salesId: string, lineNum: number) => {
        const request = this.props.context.request;
        let orderDetailUrl = request.url.requestUrl.origin;
        if (request.sitePath) {
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            orderDetailUrl = orderDetailUrl + request.sitePath;
        }
        if (salesId && request && lineNum) {
            return `${orderDetailUrl}${this.props.config.redirectToOrderDetailUrl}?salesId=${salesId}&lineNum=${lineNum}`;
        }
        return '';
    };

    private handleMouseEnterEvent = (index: number) => {
        this.setState({ mouseOverIndex: index });
    };
    private handleMouseOutEvent = () => {
        this.setState({ mouseOverIndex: 0 });
    };
    private handlePageItemsChange = async (totalItemPerPage: any, activePage: number) => {
        if (this.state.searchString) {
            await this.getRequestOrderList({ IncludeTotalCount: true, SearchTxt: this.state.searchString }, activePage);
        } else {
            await this.getRequestOrderList({ IncludeTotalCount: true }, activePage);
        }
    };

    private handleOnChangeInput = (searchString: string) => {
        this.setState({ searchString: searchString.toLowerCase() });
    };
    private onClickSearchBox = async () => {
        if (this.state.searchString) {
            await this.getRequestOrderList({ IncludeTotalCount: true, SearchTxt: this.state.searchString }, 1);
        }
    };
    private resetItems = async () => {
        await this.getRequestOrderList({ IncludeTotalCount: true }, 1);
        this.setState({
            searchString: ''
        });
    };
    public render(): JSX.Element | null {
        const viewProps: IAaaB2BOrderHistoryViewProps = {
            ...(this.props as IAaa_b2b_order_historyProps<IAaaB2BOrderHistoryData>),
            headers: this.state.headers,
            total: this.state.total,
            activePage: this.state.activePage,
            totalItemPerPage: this.state.totalItemPerPage,
            currentPageItems: this.state.currentPageItems,
            pageCount: this.state.pageCount,
            handlePageItemsChange: this.handlePageItemsChange,
            handleMouseEnterEvent: this.handleMouseEnterEvent,
            handleMouseOutEvent: this.handleMouseOutEvent,
            mouseOverIndex: this.state.mouseOverIndex,
            handleOnChangeInput: this.handleOnChangeInput,
            onClickSearchBox: this.onClickSearchBox,
            resetItems: this.resetItems,
            searchString: this.state.searchString,
            isLoading: this.state.isLoading,
            getOrderDetailPageUrl: this.getOrderDetailPageUrl
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2b_order_history;
